<template>
  <div class="main-template">
    <div hidden>
      <v-text-field />
      <v-combobox />
      <v-switch />
      <v-textarea />
    </div>
    <h1>{{ fileName }}</h1>
    <!-- {{ currentFile }} -->
    <v-breadcrumbs :items="objects" divider=">>">
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item style="cursor:pointer" @click="showProperties(item.text)">
          <h3>{{ item.text }}</h3>
        </v-breadcrumbs-item>
      </template></v-breadcrumbs
    >
    <v-tabs v-model="setupType">
      <v-tab>Data Objects</v-tab>
      <v-tab>Setup Wizard</v-tab>
    </v-tabs>
    <v-card v-if="!setupType">
      <v-row style="height:67vh; overflow-y:auto;overflow-x:hidden;">
        <v-col cols="2"
          ><h3 class="ma-2">Data Objects</h3>

          <v-autocomplete
            class="ma-2"
            v-model="model"
            label="Selected Data Object"
            :items="files"
            @change="showProperties()"
            clearable
          ></v-autocomplete>

          <v-toolbar right icon flat>
            <v-text-field v-model="newFile" dense label="New object" />
            <v-btn @click="addFile()" icon color="info">
              <v-icon>
                mdi-plus
              </v-icon></v-btn
            >
          </v-toolbar>
          <div v-if="model">
            <label>
              child objects
            </label>
            <v-list-item style="cursor:pointer" @click="showProperties(p)" dense :key="p" v-for="p in childrenObjects">
              {{ p }}
            </v-list-item>
          </div>
        </v-col>
        <v-col v-if="model" cols="10"
          ><h3 class="ma-2">Schema</h3>
          <v-combobox label="type" v-model="currentFile.type" :items="types" />
          <v-switch label="card" v-model="currentFile.card"></v-switch>
          <v-switch label="draggable" v-model="currentFile.draggable"></v-switch>
          <v-text-field label="cols" v-model="currentFile.cols"></v-text-field>
          <v-combobox label="sort" v-model="currentFile.sort" item-text="name" item-value="name" :items="properties" />
          <v-text-field label="headerColor" v-model="currentFile.headerColor"></v-text-field>
          <v-text-field label="elevation" v-model="currentFile.elevation"></v-text-field>

          <v-combobox
            multiple
            label="required"
            v-model="currentFile.required"
            :items="properties"
            item-text="name"
            item-value="name"
          />
          <!-- {{currentFile['v-bind']}} -->
          <v-bind-component
            :key="vbKey"
            label="v-bind"
            v-if="currentFile.type"
            :model="currentFile['v-bind'] || {}"
            :isTable="true"
            :items="properties"
            :objects="files"
          >
          </v-bind-component>

          <v-expansion-panels flat>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <label style="cursor:pointer" class="ma-n6">properties</label>
              </v-expansion-panel-header>
              <!-- {{ properties }} -->
              <v-expansion-panel-content>
                <v-expansion-panels :key="propertiesKey" class="ma-2">
                  <draggable style="width:100%" :list="properties" @end="updateProperties()">
                    <v-expansion-panel :key="p.name" v-for="p in properties">
                      <v-expansion-panel-header>
                        <v-edit-dialog
                          persistent
                          large
                          cancel-text="Cancel"
                          save-text="Apply"
                          @save="saveNameChange(p)"
                          @cancel="cancelNameChange"
                          @open="showPropName(p)"
                        >
                          {{ p.name }}
                          <template v-slot:input>
                            <v-text-field v-model="propName" label="Edit" single-line></v-text-field>
                          </template>
                        </v-edit-dialog>
                        <!-- 
                      <v-text-field
                        dense
                        v-model="p.name"
                        @input="updateProperties()"
                      /> -->

                        <template v-slot:actions>
                          <v-icon color="primary">
                            $expand
                          </v-icon>
                          <v-icon @click="deleteSetting(p)" color="red">mdi-delete</v-icon>
                        </template>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <div v-for="s in settings" :key="Object.keys(s)[0]">
                          <!-- {{Object.keys(s)[0]}} 
                        {{s[Object.keys(s)[0]]['component']}}
                        {{p.settings[Object.keys(s)[0]] }} -->

                          <component
                            :is="s[Object.keys(s)[0]]['component'] || 'v-text-field'"
                            :label="Object.keys(s)[0]"
                            v-model="p.settings[Object.keys(s)[0]]"
                            :model="p.settings[Object.keys(s)[0]] || {}"
                            :items="s[Object.keys(s)[0]]['items'] || properties"
                            :objects="s[Object.keys(s)[0]]['objects']"
                            :x-type="s[Object.keys(s)[0]]['x-type']"
                            :isCombo="true"
                            item-text="name"
                            item-value="name"
                          />
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </draggable>
                </v-expansion-panels>
                <v-toolbar right icon v-if="model" flat>
                  <v-text-field v-model="newProperty" dense label="New property" />
                  <!-- <v-divider /> -->
                  <v-btn @click="addProperty()" icon color="info">
                    <v-icon>
                      mdi-plus
                    </v-icon></v-btn
                  >
                </v-toolbar>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
      <hr v-if="model" />
      <v-btn class="ma-2" v-if="model" @click="save()" color="success">Save</v-btn></v-card
    >
    <v-card v-else>
      <v-setup-wizard-editor :files="objectNames" :getFile="getFile"></v-setup-wizard-editor>
    </v-card>
    <v-alert timeout="6000" dense dismissible v-if="successMessage != ''" type="success">
      {{ successMessage }}
    </v-alert>
  </div>
</template>

<script>
import axios from "axios";
import * as fun from "../plugins/common";

import draggable from "vuedraggable";
export default {
  name: "Metadata",
  components: {
    draggable,
    VBindComponent: () => import("../components/VBind.vue"),
    VSetupWizardEditor: () => import("../components/SetupWizardEditor.vue")
  },
  props: {},
  data() {
    return {
      vbKey: 1,
      files: [],
      objectNames: [],
      objects: [],
      currentFile: {},
      fileName: "",
      propName: "",
      newFile: "",
      model: "",
      types: ["object"],
      properties: [],
      propertiesKey: 0,
      childrenObjects: [],
      successMessage: "",
      newProperty: "",
      oldPropName: "",
      setupType: 0,

      settings: [
        {
          type: {
            component: "v-combobox",
            items: ["object"]
          }
        },

        { title: {} },
        {
          object_type: {
            component: "v-combobox"
          }
        },
        {
          required: {
            component: "v-combobox",
            items: ["nameRules", "emailRules", "arrayRules"]
          }
        },
        {
          "x-display": {
            component: "v-combobox",
            items: [
              "d-table",
              "d-list",
              "d-iterator",
              "v-collapsible",
              "v-switch",
              "v-combo",
              "v-address",
              "v-date-field",
              "v-time-field",
              "v-date-time",
              "v-date-range-picker",
              "v-textarea",
              "v-charge",
              "week-days",
              "days-of-month",
              "v-charge-type",
              "v-rate",
              "v-btn",
              "v-labor",
              "v-color-field"
            ]
          }
        },
        {
          "x-type": {
            component: "v-combobox",
            items: ["number", "date", "time", "password"]
          }
        },
        { cols: { "x-type": "number" } },
        { cssstyle: "" },

        { panel: { component: "v-switch" } },
        { collapsed: { component: "v-switch" } },
        { card: { component: "v-switch" } },
        { collection: { component: "v-switch" } },

        { can_add: { component: "v-switch" } },
        { canDelete: { component: "v-switch" } },
        { tabs: { component: "v-switch" } },
        { hideTitle: { component: "v-switch" } },
        { hideHeader: { component: "v-switch" } },
        { hideFooter: { component: "v-switch" } },
        { directEdit: { component: "v-switch" } },
        { hidden: { component: "v-switch" } },
        { hideInTable: { component: "v-switch" } },
        { in_expand: { component: "v-switch" } },
        { inTableEdited: { component: "v-switch" } },
        { groupBy: { component: "v-switch" } },
        { "full-width": { component: "v-switch" } },
        { drawer: { component: "v-switch" } },
        { right: { component: "v-switch" } },
        { icon: "" },
        { prependIcon: "" },
        { width: {} },
        { calculate: { component: "v-textarea" } },
        { calculatedTitle: { component: "v-textarea" } },
        { displayOnClosedHeader: { component: "v-textarea" } },
        { calculatedHeaderColor: { component: "v-textarea" } },
        { chipProperty: "" },
        { calculatedAvatar: { component: "v-textarea" } },
        { template: { component: "v-textarea" } },
        { header_value: "" },
        { headerIcon: "" },
        { default: "" },
        { calculatedDefault: { component: "v-textarea" } },
        { displayProperty: {} },
        { add_btn_title: {} },
        { name_key: {} },
        { key_obj: {} },
        // { sort: { component: "v-combobox", multiple: false } },
        {
          "v-if-parameter": {
            component: "v-combobox"
          }
        },
        { "v-if-value": "" },
        { "v-if-not-value": "" },
        { "v-if-parent": "" },
        {
          "v-bind": { component: "v-bind-component", isCombo: true }
        }
      ]
      // slides: [
      //   {
      //     name: "Slide name 1",
      //   },
      //   {
      //     name: "Slide name 2",
      //   },
      //   {
      //     name: "Slide name 3",
      //   },
      //   {
      //     name: "Slide name 4",
      //   },
      //   {
      //     name: "Slide name 5",
      //   },
      //   {
      //     name: "Slide name 6",
      //   },
      //   {
      //     name: "Slide name 7",
      //   },
      // ],
    };
  },
  mounted() {
    this.getFiles();
  },
  beforeDestroy() {},
  methods: {
    getProperties() {
      var propertyNames = [];
      this.properties.forEach(p => {
        propertyNames.push(p.name);
      });
      return propertyNames;
    },
    getFiles() {
      var that = this;
      axios.post(this.serverURL + "/get_objects").then(response => {
        that.files = response.data;
        that.objectNames = that.files.map(s => s.replace(/\.json$/i, ""));
      });
    },
    saveNameChange(p) {
      p.name = this.propName;
      if (this.oldPropName != p.name) {
        this.renameField();
      }
    },
    cancelNameChange() {},
    showPropName(p) {
      this.propName = p.name;
      this.oldPropName = fun.clone(this.propName);
    },
    addFile() {
      if (!this.newFile) {
        return;
      }
      if (!this.newFile.endsWith(".json")) {
        this.newFile = this.newFile + ".json";
      }
      this.fileName = this.newFile;
      this.currentFile = {
        properties: {},
        "v-bind": {}
      };
      this.properties = [];
      this.model = this.newFile;
      this.newFile = "";

      this.save(true);
    },
    showProperties(p) {
      this.successMessage = "";
      if (this.model) {
        var that = this;
        var f = this.model;
        if (p) {
          if (p != this.model) {
            f = p;
            if (!p.endsWith(".json")) {
              f = p + ".json";
            }

            if (
              !this.objects.filter(o => {
                return o.text == f;
              }).length
            ) {
              this.objects.push({ text: f });
            }
            var itemIndex = 0;
            this.objects.forEach((obj, i) => {
              if (obj.text == f) {
                itemIndex = i;
              }
            });
            if (itemIndex) {
              this.objects.splice(itemIndex + 1);
            }
          } else {
            this.objects = [];
            this.objects.push({ text: this.model });
          }
        } else {
          this.objects = [];
          this.objects.push({ text: this.model });
        }
        this.getFile(f);
      }
    },
    renameField() {
      var data = {
        mongo_table: this.fileName.replace(".json", ""),
        portal_id: "71",
        existing_keys: [this.oldPropName],
        new_keys: [this.propName]
      };

      axios.post(this.serverURL + "/rename_field", data).then(response => {
        console.log(response);
      });
    },
    getFile(f, feedback) {
      var that = this;
      axios.post(this.serverURL + "/get_file", { f: f }).then(response => {
        that.currentFile = response.data;
        // if (that.currentFile.type == "object" && !that.currentFile["v-bind"]) {
        //   that.currentFile["v-bind"] = {};
        // }
        that.fileName = f;
        that.childrenObjects = [];
        var list = "";

        that.settings.forEach(s => {
          if (Object.keys(s)[0] == "object_type" || Object.keys(s)[0] == "v-bind") {
            if (Object.keys(s)[0] == "object_type") {
              s[Object.keys(s)[0]].items = [];
              list = "items";
            } else {
              s[Object.keys(s)[0]].objects = [];
              list = "objects";
            }

            that.files
              .filter(f => {
                return f != this.model;
              })
              .forEach(n => {
                //  if (Object.keys(s)[0] == "object_type"){

                s[Object.keys(s)[0]][list].push(n.replace(".json", ""));
                //  }
              });
          }
        });

        that.refreshProperties();
        if (feedback) {
          feedback(that.currentFile.properties);
        }
      });
    },

    deleteSetting(p) {
      var that = this;
      this.$root.$confirm
        .open("Delete", "Confirm deleting " + p.name + "?", {
          color: "red"
        })
        .then(confirm => {
          if (confirm) {
            delete that.currentFile.properties[p.name];
            that.propertiesKey = !that.propertiesKey;
            that.refreshProperties();
          }
        });
    },
    addProperty() {
      if (!this.newProperty) {
        return;
      }
      this.currentFile.properties[this.newProperty] = {};
      this.properties.push({
        name: this.newProperty,
        settings: { "v-bind": {} }
      });
      this.newProperty = "";
      this.vbKey = !this.vbKey;
      // this.refreshProperties();
    },
    updateProperties() {
      var that = this;
      this.currentFile.properties = {};
      this.properties.forEach(p => {
        that.currentFile.properties[p.name] = p.settings;
      });
    },
    refreshProperties() {
      var that = this;
      that.properties = [];
      if (that.currentFile.properties) {
        Object.keys(that.currentFile.properties).forEach(p => {
          var prop = {
            name: p,
            settings: that.currentFile.properties[p]
          };
          that.properties.push(prop);
          if (that.currentFile.properties[p]["object_type"]) {
            that.childrenObjects.push(that.currentFile.properties[p]["object_type"]);
          }
        });
      }
      var v_if_value = {};
      that.settings.forEach(s => {
        if (Object.keys(s)[0] == "v-if-component") {
          s.component.items = that.getProperties();
        }
      });

      that.vbKey = !that.vbKey;
    },
    save(isNew) {
      var that = this;
      // this.currentFile = JSON.parse(JSON.stringify(this.currentFile));
      if (
        this.currentFile["v-bind"] &&
        this.currentFile["v-bind"].editedItem &&
        this.currentFile["v-bind"].editedItem == {}
      ) {
        this.currentFile["v-bind"].editedItem = null;
      }

      // this.$refs.assistant.assistantSettings.forEach((a) => {
      //   var k = Object.keys(a)[0];
      //   var v = Object.keys(a)[1];
      //   that.currentFile["v-bind"]["assistant"][k] =
      //     that.currentFile["v-bind"][k];
      //   delete that.currentFile["v-bind"][k];
      // });

      axios
        .post(this.serverURL + "/add_file", {
          file_name: this.fileName,
          json: this.currentFile,
          properties: this.properties
        })
        .then(response => {
          console.log(response);
          that.successMessage = response.data;
          if (isNew) {
            that.getFiles();
            that.showProperties(that.fileName);
          }

          that.getFile(that.fileName);
        });
    }
  }
};
</script>

<style lang="css" scoped></style>
